<div class="knhc-player text-light">
  @if (displayInfo() && (npName() || npPerformer())) {
    <div class="top-text text-sm line-clamp-2 pl-1 pr-1 text-center sm:text-base">
      <span class="font-bold">{{ npName() }}</span>
      @if (npName() && npPerformer()) {
        &bull;
      }
      <span class="font-italic">{{ npPerformer() }}</span>
    </div>
  }

  <div class="player-wrapper">
    <pv2-player canScrubBack="false"></pv2-player>
  </div>
</div>
